import type { UserProfile } from '@zen/Auth/UserDataProvider/types';

export const isCurrentUser = (userProfile: UserProfile, email: string): boolean => {
  return userProfile.email === email;
};
